
import { Observable,  of as observableOf } from "rxjs";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { map } from "rxjs/operators";
import { environment as env } from "../../../environments/environment";
import { NSHttpClient } from "../types";
import { ResponseService } from "./response.service";

@Injectable()
export class FileRequestsService {
    public bearerToken: string;

    constructor(private apollo: Apollo,
                private http: HttpClient,
                private response: ResponseService) {
    }

    public getFiles(query, params?): Observable<NSHttpClient.APIResponse<any>> {
        return this.apollo
            .query(((query(params))) as any).pipe(
            map(this.response.formatResponseBody),
            map((res) => ({data: res.data.files || []})));
    }

    public postFiles(body, subPath): Observable<any> {
        if (!body.files) {
            return observableOf(false);
        }
        const url = `${env.apiPath}/files/${subPath}`;
        const formData: any = new FormData();
        formData.append("id", body.id);
        body.files.forEach((file) => formData.append("files", file, file.name));
        return this.http.post(url, formData);
    }

    public deleteFile(id, subPath: string): Observable<any> {
        return this.http.delete(`${env.apiPath}/files/${subPath}/${id}`, {responseType: "text"});
    }
}
